import {
    WarningMailTipMailBoxFull,
    WarningMailTipMailBoxFullMultiple,
} from './getMailboxFullMessageViewState.locstring.json';
import loc from 'owa-localize';
import {
    InfoBarMessageViewState,
    InfoBarMessageRank,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';

import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { getGenericMessageElementAndParts } from './getGenericMessageParts';
import { MailTipsCategory } from '../datapoints';

/**
 * returns InfoBarMessageViewState for recipients whose mailboxes are full.
 * returns null if no recipient mailboxes are full.
 */
export default (
    recipients: EmailAddressWrapper[],
    onRemoveRecipientsClick: (recipients: EmailAddressWrapper[]) => void
): InfoBarMessageViewState => {
    if (!recipients.length) {
        return null;
    }
    const [messageElement, messageParts, messageString] = getGenericMessageElementAndParts(
        recipients,
        loc(WarningMailTipMailBoxFull),
        loc(WarningMailTipMailBoxFullMultiple),
        onRemoveRecipientsClick,
        MailTipsCategory.MailboxFull
    );
    return {
        key: 'MailboxFull',
        message: messageString,
        messageElement,
        messageParts,
        rank: InfoBarMessageRank.Error,
        source: InfoBarMessageSource.Compose,
    };
};
